module.exports = __webpack_public_path__ + "img/pw.c0776ae9.svg";